module.exports = __webpack_public_path__ + "static/media/downloadhandleout.a5aaaf41.png";